import { MachinesResponse } from "@needle-management/shared-models";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import {  CommonResponseModel } from '@needle-management/shared-models';
import { MachinesCreateDto, MachinesToggleDto } from "./dto";
import { MachinesService } from "./machines-service";

@ApiTags('Machines')
@Controller('machine')
export class MachinesController {
    constructor(private readonly machinesService: MachinesService) { }


    @Post('/createMachineTypes')
    @ApiBody({})
    async createMachineTypes(@Body() req: MachinesCreateDto): Promise<CommonResponseModel> {
        return await this.machinesService.createMachineTypes(req);
    }
    @Post('/getAllMachineTypes')
    async getAllMachineTypes(@Body() dto: { }): Promise<MachinesResponse> {
        return await this.machinesService.getAllMachineTypes(dto);
    }


    @Post('/toggleMachineTypes')
    async toggleMachineTypes(@Body() dto: MachinesToggleDto): Promise<CommonResponseModel> {
        return await this.machinesService.toggleMachineTypes(dto);
    }

    
    @Post('/getActiveMachines')
    async getActiveMachines(): Promise<CommonResponseModel> {
        return await this.machinesService.getActiveMachines();
    }



}